'use client'

interface SectionTabsProps {
  activeTab: string
  onTabChange: (tabId: string) => void
}

interface SectionTab {
  label: string
  id: string
}

const tabs: SectionTab[] = [
  { label: 'About', id: 'about' },
  { label: 'Specialties', id: 'specialties' },
  { label: 'Prescribers', id: 'prescribers' },
  { label: 'Opening Hours', id: 'clinic-hours' },
]

export default function ClinicSectionTabs({ activeTab, onTabChange }: SectionTabsProps) {
  return (
    <div className='mb-8 overflow-x-auto border-b border-gray-300'>
      <div className='flex min-w-max gap-8 px-1 sm:gap-10 lg:min-w-0 lg:justify-between lg:gap-0 lg:pl-5 lg:pr-0'>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              shrink-0 pb-4 text-base font-medium transition-colors
              ${
                activeTab === tab.id
                  ? 'text-[#F59405] underline underline-offset-4 font-semibold text-base'
                  : 'text-black text-base font-normal'
              }
            `}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  )
}
